(function() {
    'use strict';

    angular.module('montage')
        .controller('MontageRealizationController', MontageRealizationController);

    MontageRealizationController.$inject = ['$q', 'montagePk', '$uibModal', '$uibModalInstance', 'notificationSrvc', 'checkModelPermissionsSrvc', 'lodashService', 'montageDataSrvc', 'montageSrvc', 'montagePermissionsConst', 'montageMessagesConst'];

    function MontageRealizationController($q, montagePk, $uibModal, $uibModalInstance, notificationSrvc, checkModelPermissionsSrvc, lodashService, montageDataSrvc, montageSrvc, montagePermissionsConst, montageMessagesConst) {
        var self = this;
        var updateMontageStatus = null;
        var beforeStatuses = []

        self.montage = null;

        self.close = close;
        self.startMontage = startMontage;
        self.finishMontage = finishMontage;
        self.isStartedDisabled = isStartedDisabled;
        self.isFinishedDisabled = isFinishedDisabled;

        self.hideBeforeStatus = hideBeforeStatus;

        self.setClosedMontage = setClosedMontage;
        self.setPrintedMontage = setPrintedMontage;
        self.setRadiatedMontage = setRadiatedMontage;
        self.setMountedMontage = setMountedMontage;

        self.isClosedDisplayed = isClosedDisplayed;
        self.isMountedDisplayed = isMountedDisplayed;
        self.isRadiatedDisplayed = isRadiatedDisplayed;
        self.isPrintedDisplayed = isPrintedDisplayed;

        self.isClosedDisabled = montageSrvc.isClosedDisabled;
        self.isMountedDisabled = montageSrvc.isMountedDisabled;
        self.isRadiatedDisabled = montageSrvc.isRadiatedDisabled;
        self.isPrintedDisabled = montageSrvc.isPrintedDisabled;

        self.hasStatusesViewPermission = hasStatusesViewPermission;
        self.hasStatusesCreatePermission = hasStatusesCreatePermission;
        self.hasStatusChangePerm = false;
        activate();

        function activate() {
            self.montage = montageDataSrvc.retrieve({pk: montagePk}).$promise.then(
                function (response) {
                    self.montage = response;
                    fillMontage();
                }, function (response){}
            )
        }


        self.contextMenu = [{

        }, {
            html: function($itemScope) {
                return getContextItemHtml(
                    $itemScope.row.mounted,
                    montageSrvc.isMountedDisabled($itemScope.row),
                    'Zmontowany');
            },
            displayed: function() {
                return !checkModelPermissionsSrvc.isDenied(
                    montagePermissionsConst.set_mounted_montage_permission);
            },
            enabled: function($itemScope, $event, modelValue) {
                return !montageSrvc.isMountedDisabled($itemScope.row);
            },
            click: function ($itemScope, $event, modelValue, text, $li) {
                return montageSrvc.setMountedMontage($itemScope.row);
            }
        }, {
            html: function($itemScope) {
                return getContextItemHtml(
                    $itemScope.row.radiated,
                    montageSrvc.isRadiatedDisabled($itemScope.row),
                    'Naświetlony');
            },
            displayed: function() {
                return !checkModelPermissionsSrvc.isDenied(
                    montagePermissionsConst.set_radiated_montage_permission);
            },
            enabled: function($itemScope, $event, modelValue) {
                return !montageSrvc.isRadiatedDisabled($itemScope.row);
            },
            click: function ($itemScope, $event, modelValue, text, $li) {
                return montageSrvc.setRadiatedMontage($itemScope.row);
            }
        }, {
            html: function($itemScope) {
                return getContextItemHtml(
                    $itemScope.row.printed,
                    montageSrvc.isPrintedDisabled($itemScope.row),
                    'Wydrukowany');
            },
            displayed: function() {
                return !checkModelPermissionsSrvc.isDenied(
                    montagePermissionsConst.set_printed_montage_permission);
            },
            enabled: function($itemScope, $event, modelValue) {
                return !montageSrvc.isPrintedDisabled($itemScope.row);
            },
            click: function ($itemScope, $event, modelValue, text, $li) {
                return montageSrvc.setPrintedMontage($itemScope.row);
            }
        }];



        function fillMontage() {
            if (self.montage.printed) {
                self.montage.prev_process_stage = 'Naświetlony';
                self.montage.process_stage = 'Wydrukowany';
                self.montage.next_process_stage = null;
                beforeStatuses = ['closed', 'mounted', 'radiated', 'printed'];
            } else if (self.montage.radiated) {
                self.montage.prev_process_stage = 'Naświetlony';
                self.montage.process_stage = 'Drukowanie';
                self.montage.next_process_stage = 'Wydrukowany';
                updateMontageStatus = montageSrvc.setPrintedMontage;
                beforeStatuses = ['closed', 'mounted', 'radiated'];
                self.hasStatusChangePerm = !checkModelPermissionsSrvc.isDenied(montagePermissionsConst.set_printed_montage_permission);
            } else if (self.montage.mounted) {
                self.montage.prev_process_stage = 'Zmontowany';
                self.montage.process_stage = 'Naświetlanie';
                self.montage.next_process_stage = 'Naświetlony';
                updateMontageStatus = montageSrvc.setRadiatedMontage;
                beforeStatuses = ['closed', 'mounted'];
                self.hasStatusChangePerm = !checkModelPermissionsSrvc.isDenied(montagePermissionsConst.set_radiated_montage_permission);
            } else if (self.montage.closed) {
                self.montage.prev_process_stage = 'Zamknięty';
                self.montage.process_stage = 'Montaż';
                self.montage.next_process_stage = 'Zmontowany';
                updateMontageStatus = montageSrvc.setMountedMontage;
                beforeStatuses = ['closed'];
                self.hasStatusChangePerm = !checkModelPermissionsSrvc.isDenied(montagePermissionsConst.set_mounted_montage_permission);
            } else {
                self.montage.prev_process_stage = null;
                self.montage.process_stage = 'Zamykanie';
                self.montage.next_process_stage = 'Zamknięty';
                updateMontageStatus = montageSrvc.setClosedMontage;
                self.hasStatusChangePerm = !checkModelPermissionsSrvc.isDenied(montagePermissionsConst.set_closed_montage_permission);
            }
        }

        function isClosedDisplayed() {
            return !checkModelPermissionsSrvc.isDenied(
                montagePermissionsConst.set_closed_montage_permission);
        }

        function isMountedDisplayed() {
            return !checkModelPermissionsSrvc.isDenied(
                montagePermissionsConst.set_mounted_montage_permission);
        }

        function isRadiatedDisplayed() {
            return !checkModelPermissionsSrvc.isDenied(
                montagePermissionsConst.set_radiated_montage_permission);
        }

        function isPrintedDisplayed() {
            return !checkModelPermissionsSrvc.isDenied(
                montagePermissionsConst.set_printed_montage_permission);
        }

        function setClosedMontage() {
            montageDataSrvc.stateUpdate({
                pk: self.montage.pk
            }, {
                closed: false
            }).$promise.then(
                function(response) {
                    self.montage.closed = false;
                    fillMontage();
                    notificationSrvc.notification("success", montageMessagesConst.unclosed);
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.closed.join('; '));
                }
            );

        }
        function setPrintedMontage() {
            montageDataSrvc.stateUpdate({
                pk: self.montage.pk
            }, {
                printed: false
            }).$promise.then(
                function(response) {
                    self.montage.printed = false;
                    fillMontage();
                    notificationSrvc.notification("success", montageMessagesConst.unprinted);
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.printed.join('; '));
                }
            );
        }
        function setRadiatedMontage() {
            montageDataSrvc.stateUpdate({
                pk: self.montage.pk
            }, {
                radiated: false
            }).$promise.then(
                function(response) {
                    self.montage.radiated = false;
                    fillMontage();
                    notificationSrvc.notification("success", montageMessagesConst.unradiated);
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.radiated.join('; '));
                }
            );
        }
        function setMountedMontage() {
            montageDataSrvc.stateUpdate({
                pk: self.montage.pk
            }, {
                mounted: false
            }).$promise.then(
                function(response) {
                    self.montage.mounted = false;
                    fillMontage();
                    notificationSrvc.notification("success", montageMessagesConst.unmounted);
                },
                function(response) {
                    notificationSrvc.notification("error", response.data.mounted.join('; '));
                }
            );
        }


        function hideBeforeStatus(status) {
            return beforeStatuses.indexOf(status) < 0
        }

        function close() {
            $uibModalInstance.close();
        }

        function hasStatusesViewPermission() {
            return !checkModelPermissionsSrvc.isDenied(
                orderProductProcessStageStatusPermissionsConst.view);
        }

        function hasStatusesCreatePermission() {
            return !checkModelPermissionsSrvc.isDenied(
                orderProductProcessStageStatusPermissionsConst.add);
        }

        function startMontage() {
            if (self.hasStatusChangePerm) {
                montageDataSrvc.startMontage({ pk: self.montage.pk }).$promise.then(
                function(response) {
                    self.montage.realization_started = true;
                }, function(response){}
              )
            }
        }

        function finishMontage() {
            updateMontageStatus(self.montage);
            $uibModalInstance.close();
        }

        function isStartedDisabled() {
            return self.montage.realization_started | (self.montage.next_process_stage === null);
        }

        function isFinishedDisabled() {
            if (self.montage.realization_started) {
                if ((self.montage.next_process_stage === null)){
                    return true;
                } else {
                    return false;
                }
            } else {
                return true;
            }
        }

    }
})();
